import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'

import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
/*----tree structure--*/
import {LOAD_CHILDREN_OPTIONS,Treeselect} from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';
/*----//tree structure--*/


export default {
    name: 'appuserprojectroles',
    components: {
        VueElementLoading,
        Treeselect
    },
    data: function() {

        return {
          projectRoles: [],
          show:false,
          iptrackData:'',

        }
    },
    created: function() {

    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        this.localuserid = userdetail.userid;

        this.getProjectData();

    },
    methods: {

      getProjectData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.show = true;
          axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'getActiveProjectRoleList',
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
              })
              .then(async result => {
                this.projectRoles = result.data.data;
                this.show = false;

                this.$nextTick(() => {
                  var toggler = document.getElementsByClassName("caret");
                  var i;
                  for (i = 0; i < toggler.length; i++) {
                    toggler[i].addEventListener("click", function() {
                      this.parentElement.querySelector(".nested").classList.toggle("active");
                      let count = 0;
                      if(this.parentElement.id){
                        count = $("#"+this.parentElement.id+" ul").children().length;
                      }
                      if(count>0 || this.parentElement.id==""){
                        this.classList.toggle("caret-down");
                      }
                    });
                  }
                });

              }, error => {
                  console.error(error)
              })
      },

    }
}



// WEBPACK FOOTER //
// ./src/views/components/projectroleaccessview/projectroleaccessview.component.js